export default __webpack_public_path__ + "static/media/handover.f628ae6d.hbs";